/*
 * mtcTabs- A jQuery plugin for responsive tabs
 * Version : 0.1
 * Author : Adrian Robb
 */


;(function ($, window, document, undefined) {

    'use strict';

    // Create the defaults once
    var instanceID = 1,
        pluginName = "mtcTabs",
        plugin,
        defaults = {
            navClass: "tabsNav", //class name for tabs navigation element
            paneContainerClass: "tabsContent", //class name for tab panes container
            paneClass: "tabPane", //class name for each tab pane
            breakpoint: 860, //responsive breakpoint
            mode: "default", //mode (default or fade)
            responsiveMode: "accordion", //the mode the tabs should change to when breakpoint reached (accordion, select)
            fadeSpeed: 500, //fadeIn and fadeOut speed
            slideUpSpeed: 500, //slideUp duration
            slideUpEasing: 'swing', //slideUp easing value
            slideDownSpeed: 500, //slideDown duration
            slideDownEasing: 'swing' //slideUp easing value
        };

    // The actual plugin constructor
    function Plugin(element, options) {
        plugin = this;
        plugin.element = element;
        plugin.$this = $(plugin.element);
        plugin.settings = $.extend({}, defaults, options);
        plugin.$defaults = plugin.defaults;
        plugin.name = pluginName;
        plugin.ID =  instanceID++;
        plugin.init();
    }

    Plugin.prototype = {

        init: function () {
            // Assign plugin to self to pass to methods
            var self = plugin,
                containerID = plugin.name + plugin.ID;

            // Give container ID
            plugin.$this.attr('id', containerID);

            // loop through tabPanes and give each as ID
            plugin.$this.find('.' + plugin.settings.paneClass).each(function (i) {
                var tabID = plugin.name + plugin.ID + 'tab-' + i;
                $(this).attr('id', tabID);
            });

            // hide tab pane
            plugin.$this.find('.' + plugin.settings.paneClass).hide();
            plugin.$this.find('.' + plugin.settings.paneClass).addClass('closed');
            // show first tab pane
            plugin.$this.find('.' + plugin.settings.paneClass).first().show();
            plugin.$this.find('.' + plugin.settings.paneClass).first().addClass('open').removeClass('closed');

            // Tabs nav
            plugin.createTabsNav(plugin.$this.find('.' + plugin.settings.paneContainerClass));

            // Tabs nav click event
            plugin.onNavClick(self);

            // Add active to first tab
            plugin.$this.find('.' + plugin.settings.navClass).find('a').first().addClass("active");

            // check tabs nav on resize and initial load
            // uses windowResize function with tabsNavResize as callback
            // uses self variable which equals this plugin
            plugin.tabsNavResize(self);

            plugin.windowResize(function () {
                plugin.tabsNavResize(self);
            }, 350);

        }, // end of init

        // Resize function
        windowResize: function (callback, time) {
            var resizeTimer;
            $(window).on('resize', function (e) {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function () {
                    callback();
                }, time);
            });
        },

        // Destroy plugin
        destroy: function () {
            // Remove elements, unregister listeners, etc
            plugin.$this.find('.' + plugin.settings.navClass + 'Link').remove();
            plugin.$this.find('.' + plugin.settings.navClass).remove();
            plugin.$this.find('.' + plugin.settings.paneClass).removeAttr('style');
            if (plugin.$this.find('#' + plugin.name + plugin.ID + "Select")) {
                plugin.$this.find('#' + plugin.name + plugin.ID + "Select").remove();
                $('.' + plugin.name + plugin.ID + "Select").removeClass(plugin.name + plugin.ID + "Select");
            }
            // Remove data
            plugin.$this.removeData();
        },

        // Function to create tabs navigation links
        createTabsNav: function (target) {
            var className =  plugin.settings.navClass,
                navWrap = $('<div>', {'class': className });
            navWrap.insertBefore(target);

            // create tab nav links and append
            target.children().each(function (i) {
                var link = '#' + $(this).attr('id'),
                    title = $(this).attr('data-title'),
                    elClass = plugin.settings.navClass + 'Link',
                    tabLink = $('<a>', {
                        'class': elClass,
                        href: link,
                        text: title
                    });
                // append tab nav
                tabLink.appendTo(plugin.$this.find(navWrap));
            });
        },

        // Function to change navigation
        // Based on responsiveMode and breakpoint
        tabsNavResize: function (plugin) {

            plugin.$this.find('.' + plugin.settings.paneContainerClass).css('height', 'auto');

            // if responsive mode is accordion
            switch (plugin.settings.responsiveMode) {

                case "accordion":
                    var className = plugin.name + "Accordion";

                    // if below breakpoint toggle accordion class
                    if ($(window).width() < plugin.settings.breakpoint) {
                        plugin.$this.addClass(className);
                    } else {
                        plugin.$this.removeClass(className);
                    }

                    // If accordion class then move nav links to content area
                    if (plugin.$this.hasClass(className)) {
                        plugin.$this.find('.' + plugin.settings.navClass).find('a').each(function () {
                            var link = $(this).attr('href');
                            $(this).addClass('title');
                            $(this).insertBefore(link);
                        });
                        plugin.$this.find('.' + plugin.settings.navClass).hide();

                        //refresh clicks
                        plugin.onNavClick(plugin);

                    } else if (plugin.$this.find('.' + plugin.settings.paneContainerClass).length) {
                        plugin.$this.find('.' + plugin.settings.navClass).show();
                        plugin.$this.find('.' + plugin.settings.navClass + 'Link').each(function () {
                            $(this).removeClass('title');
                            $(this).appendTo(plugin.$this.find('.' + plugin.settings.navClass));
                        });
                    }
                    break;

                // if responsive mode is select
                case "select":
                    var className = plugin.name + plugin.ID + "Select",
                        selectBoxHtml,
                        selected,
                        selectTarget;

                    // if below breakpoint toggle accordion class
                    if ($(window).width() < plugin.settings.breakpoint) {
                        plugin.$this.addClass(className);
                    } else {
                        plugin.$this.removeClass(className);
                    }

                    // If select class then add select box
                    if (plugin.$this.hasClass(className) && !plugin.$this.find('#' + className).length) {
                        // create select box html
                        selectBoxHtml = $('<select>', {
                            id: className
                        });

                        // create tab nav links and append
                        plugin.$this.find('.' + plugin.settings.navClass).find('a').each(function (i) {
                            var link = $(this).attr('href'),
                                title = $(this).text(),
                                elClass = plugin.settings.navClass + 'Link',
                                selectOption = $('<option>', {
                                    'class': elClass,
                                    id: link + 'Select',
                                    value: link,
                                    text: title
                                });

                            //append to navWrap
                            selectOption.appendTo(selectBoxHtml);
                        });

                        // insert select box
                        selectTarget = plugin.$this.find('.' + plugin.settings.paneContainerClass);
                        selectBoxHtml.insertBefore(selectTarget);

                        // set selected
                        selected = selectTarget.find('.open').attr('id');
                        $('#' + className).val('#' + selected);

                        // refresh clicks
                        plugin.onNavClick(plugin);

                        // hide nav
                        plugin.$this.find('.' + plugin.settings.navClass).hide();

                        // Else remove select box
                    } else if (!plugin.$this.hasClass(className) && plugin.$this.find('#' + className).length) {
                        plugin.$this.find('#' + className).remove();

                        // show nav
                        plugin.$this.find('.' + plugin.settings.navClass).show();
                    }
                    break;
                default:
            }

        },

        // Function for when navigation links are clicked
        // Hide/show, slideToggle, fadeIn/Out, slide
        // Add/remove active class
        onNavClick: function (plugin) {

            var el = '.' + plugin.settings.navClass + 'Link';

            plugin.$this.find(el).off();
            plugin.$this.find(el).on('click', function (e) {
                // killclick
                e.preventDefault();
                e.stopPropagation();

                // show/hide events
                var link = $(this).attr('href');
                link = plugin.$this.find(link);

                // if not currently being animated
                if (!$('.' + plugin.settings.paneClass).is(':animated')) {
                    // toggle open/close classes
                    link.toggleClass('open').removeClass('closed');
                    link.siblings('.' + plugin.settings.paneClass).addClass('closed').removeClass('open');

                    // add and remove active class
                    $(this).siblings('a').removeClass('active');
                    $(this).addClass('active');
                }

                // if accordion then slideToggle
                if (plugin.$this.hasClass(plugin.name + 'Accordion')) {
                    var slideDownSpeed = plugin.settings.slideDownSpeed,
                        slideUpSpeed = plugin.settings.slideUpSpeed,
                        slideDownEasing = plugin.settings.slideDownEasing,
                        slideUpEasing = plugin.settings.slideUpEasing;
                    if (!$('.' + plugin.settings.paneClass).is(':animated')) {
                        link.siblings('.' + plugin.settings.paneClass).slideUp(slideUpSpeed, slideUpEasing);
                        link.slideDown(slideDownSpeed, slideDownEasing);
                    }
                    // if fade fade elements
                } else if (plugin.settings.mode === 'fade') {
                    var fadeSpeed = plugin.settings.fadeSpeed;
                    // fade siblings out and element link in
                    if (!$('.' + plugin.settings.paneClass).is(':animated')) {
                        link.siblings('.' + plugin.settings.paneClass).fadeOut(fadeSpeed);

                        link.siblings('.' + plugin.settings.paneClass).promise().done(function () {
                            link.fadeIn(fadeSpeed);
                        });
                    }
                    // else hide/show elements
                } else {
                    link.siblings('.' + plugin.settings.paneClass).hide();
                    link.show();
                }
            }); // end click

            //on select box change
            if (plugin.$this.find('#' + plugin.name + plugin.ID + 'Select')) {
                plugin.$this.find('#' + plugin.name + plugin.ID + 'Select').off();
                plugin.$this.find('#' + plugin.name + plugin.ID + 'Select').on('change', function (e) {
                    var link = $(this).val(),
                        active = link;
                    link = plugin.$this.find(link);
                    // show the active tab and hide all sibling tabs
                    link.show().siblings('.' + plugin.settings.paneClass).hide();

                    // toggle open/close classes
                    link.toggleClass('open').removeClass('closed');
                    link.siblings('.' + plugin.settings.paneClass).addClass('closed').removeClass('open');

                    // add and remove active class
                    plugin.$this.find('.' + plugin.settings.navClass + 'Link').each(function () {
                        if ($(this).attr('href') === active) {
                            $(this).siblings('a').removeClass('active');
                            $(this).addClass('active');
                        }
                    });
                });
            }
        }
    };


    /*
     A really lightweight plugin wrapper around the constructor,
     preventing against multiple instantiations
     */
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName,
                    new Plugin(this, options));
            }
        });
    };

})(jQuery, window, document);